var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spirit"
  }, [_c('header', {
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [(_vm.displayMode == 2) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "companyName"
  }, [(_vm.companyName == '') ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "0"
    }
  }, [_vm._v("首页")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "orderAndService"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    attrs: {
      "src": _vm.imgUrl + 'callbtn.png',
      "alt": "客服电话logo"
    },
    on: {
      "click": _vm.callgo
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "order",
    on: {
      "click": _vm.callgo
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgUrl + 'im_logo.png',
      "alt": "单据logo"
    },
    on: {
      "click": _vm.workOrder
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.workOrder
    }
  }, [_vm._v("我的单据")]), _vm._v(" "), (_vm.vip && _vm.turnToIm && _vm.visitorVipLevel != null && _vm.limitVipLevel != null && _vm.visitorVipLevel >= _vm.limitVipLevel) ? _c('img', {
    attrs: {
      "src": _vm.imgUrl + 'im_service.png',
      "alt": "在线客服logo"
    },
    on: {
      "click": _vm.intoIm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vip && _vm.turnToIm && _vm.visitorVipLevel != null && _vm.limitVipLevel != null && _vm.visitorVipLevel >= _vm.limitVipLevel) ? _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.intoIm
    }
  }, [_vm._v("在线客服")]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "chat"
  }, [_vm._l((_vm.spiritSession), function(item, index) {
    return [(item.type == 1) ? _c('div', {
      staticClass: "service"
    }, [_c('div', {
      staticClass: "serviceImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.spiritSrc,
        "alt": "系统头像"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "serviceSession"
    }, [_c('span', {
      staticClass: "sessionSpan"
    }), _vm._v(" "), _c('div', {
      staticClass: "chatText"
    }, [_c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "sessionDiv"
    }), _vm._v(" "), (item.workOrders && item.workOrders.length > 0) ? _c('div', {
      staticClass: "workOrder-box"
    }, _vm._l((item.workOrders), function(obj) {
      return _c('div', {
        key: obj.id,
        staticClass: "workOrder-item"
      }, [_c('p', {
        staticClass: "workOrder-btn",
        on: {
          "click": function($event) {
            _vm.goForm(obj)
          }
        }
      }, [_vm._v(_vm._s(obj.name))])])
    })) : _vm._e(), _vm._v(" "), (item.evaluateShow) ? _c('p', {
      staticClass: "sessionBar"
    }) : _vm._e(), _vm._v(" "), (item.evaluateShow && item.questionId != '0') ? _c('div', {
      staticClass: "evaluateDiv"
    }, [(!item.isEvaluate) ? _c('p', {
      staticClass: "evalP"
    }, [_vm._v("评价有惊喜哦~~")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "evaluate"
    }, [(!item.isEvaluate) ? _c('div', {
      staticClass: "evalDiv"
    }, [_c('div', {
      staticClass: "evaluateP",
      style: ({
        backgroundColor: _vm.boxBodyColor,
        borderColor: _vm.boxBodyColor
      }),
      on: {
        "click": function($event) {
          _vm.getEvaluate(3, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgUrl + 'zanT.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "getP"
    }, [_vm._v("解决")])])]) : _vm._e(), _vm._v(" "), (!item.isEvaluate) ? _c('p', {
      staticClass: "bar"
    }) : _vm._e(), _vm._v(" "), (!item.isEvaluate) ? _c('div', {
      staticClass: "evalDiv"
    }, [_c('div', {
      staticClass: "evaluateP",
      style: ({
        backgroundColor: _vm.boxBodyColor,
        borderColor: _vm.boxBodyColor
      }),
      on: {
        "click": function($event) {
          _vm.getEvaluate(1, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgUrl + 'zan.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "getP"
    }, [_vm._v("未解决")])])]) : _c('p', {
      staticClass: "evaluated",
      staticStyle: {
        "padding-top": "20px"
      }
    }, [_vm._v("感谢您的评价")])]), _vm._v(" "), (item.relativeQuestions && item.relativeQuestions.length > 0) ? _c('p', {
      staticClass: "evaluateBar"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.relativeQuestions && item.relativeQuestions.length > 0 && item.evaluateShow) ? _c('p', {
      staticClass: "topFiveP"
    }, [_vm._v("相关问题推荐")]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "topFive"
    }, _vm._l((item.relativeQuestions), function(relativeQ, indexF) {
      return _c('li', [_c('a', {
        attrs: {
          "href": "javaScript:void(0)"
        },
        on: {
          "click": function($event) {
            _vm.getTopFive(relativeQ)
          }
        }
      }, [_vm._v(_vm._s(relativeQ))])])
    }))])])]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
      staticClass: "user"
    }, [_c('span', {
      staticClass: "sessionUser"
    }), _vm._v(" "), _c('div', {
      staticClass: "userSession"
    }, [_c('div', {
      staticClass: "userText"
    }, _vm._l((item.content), function(i) {
      return _c('p', [_vm._v(_vm._s(i))])
    }))]), _vm._v(" "), _vm._m(0, true)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('footer', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatContent),
      expression: "chatContent"
    }],
    staticClass: "chatContent",
    attrs: {
      "maxlength": "140"
    },
    domProps: {
      "value": (_vm.chatContent)
    },
    on: {
      "keyup": function($event) {
        _vm.sendMsg(_vm.chatContent, $event)
      },
      "keydown": function($event) {
        _vm.sendMsg1(_vm.chatContent, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send"
  }, [_c('span', [_vm._v("按下Ctrl+Enter换行")]), _vm._v(" "), _c('el-button', {
    staticClass: "sendBtn",
    style: ({
      backgroundColor: _vm.boxBodyColor,
      borderColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.getTopFive(_vm.chatContent)
      }
    }
  }, [_vm._v("发送")])], 1), _vm._v(" "), (_vm.lenovoShow) ? _c('div', {
    staticClass: "lenovo"
  }, _vm._l((_vm.questions), function(relativeQ, indexF) {
    return _c('div', [_c('a', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (relativeQ.html),
        expression: "relativeQ.html"
      }],
      attrs: {
        "href": "javaScript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.getTopFive(relativeQ.content)
        }
      }
    })])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(1), _vm._v(" "), _c('nav', [_c('ul', _vm._l((_vm.hotArr), function(hotItem, index) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "javaScript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.getTopFive(hotItem)
        }
      }
    }, [_vm._v(_vm._s(hotItem))])])
  }))])])]), _vm._v(" "), (_vm.showImgMask && (_vm.geen == -1)) ? _c('div', {
    staticClass: "imgMask",
    on: {
      "click": function($event) {
        _vm.magnify(_vm.imgMasksrc)
      },
      "mousewheel": function($event) {
        _vm.bbimg()
      }
    }
  }, [_c('img', {
    ref: "img",
    attrs: {
      "src": _vm.imgMasksrc,
      "alt": "放大图"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stopImg($event)
      }
    }
  })]) : (_vm.showImgMask && (_vm.geen > -1)) ? _c('div', {
    staticClass: "imgMask",
    on: {
      "click": function($event) {
        _vm.magnify(_vm.imgMasksrc)
      },
      "DOMMouseScroll": function($event) {
        _vm.bbimg2()
      }
    }
  }, [_c('img', {
    ref: "img",
    attrs: {
      "src": _vm.imgMasksrc,
      "alt": "放大图"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stopImg($event)
      }
    }
  })]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/assets/im_group_10.png"),
      "alt": "用户头像"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotTitle"
  }, [_c('p', [_vm._v("热点问题")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8807eac8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/spirit/spirit.vue
// module id = D7uF
// module chunks = 1